import mod from "-!./HoursDetail.js?vue&type=script&lang=js&"; export default mod; export * from "-!./HoursDetail.js?vue&type=script&lang=js&"